module.exports = __webpack_public_path__ + "static/media/addnewProject.d7215b04.png";